import { z } from 'zod';
import { Equipment } from './equipment.model';

export const QuoteItemEquipment = z.object({
  equipment: Equipment,
  shifts: z.coerce.number().int(),
  hours_per_shift: z.string(),
  days_per_year: z.coerce.number().int(),
  equipment_efficiency: z.string(),
  equipment_availability_hours_per_year: z.string().nullable(),
  amortization_per_hour: z.string().nullable(),
  run_cost_per_hour: z.string().nullable(),
});

export type QuoteItemEquipment = z.infer<typeof QuoteItemEquipment>;
